/* eslint-disable import/no-unresolved */
import React from 'react';
// Icons
import Alarm from '../../../assets/icons/alarm.svg?react';
import ArrowDown from '../../../assets/icons/arrow-down.svg?react';
import ArrowSquareLeft from '../../../assets/icons/arrow-square-left.svg?react';
import Calendar from '../../../assets/icons/calendar.svg?react';
import Cross from '../../../assets/icons/cross.svg?react';
import Danger from '../../../assets/icons/danger.svg?react';
import Edit from '../../../assets/icons/edit.svg?react';
import Eye from '../../../assets/icons/eye.svg?react';
import EyeSlash from '../../../assets/icons/eye-slash.svg?react';
import Forbidden from '../../../assets/icons/forbidden.svg?react';
import HappyEmoji from '../../../assets/icons/happyemoji.svg?react';
import Home from '../../../assets/icons/home.svg?react';
import InfoCircle from '../../../assets/icons/info-circle.svg?react';
import Location from '../../../assets/icons/location.svg?react';
import Menu from '../../../assets/icons/menu.svg?react';
import Notification from '../../../assets/icons/notification.svg?react';
import PresentationChart from '../../../assets/icons/presention-chart.svg?react';
import Profile2Users from '../../../assets/icons/profile-2user.svg?react';
import SettingAlt from '../../../assets/icons/setting-alt.svg?react';
import Setting from '../../../assets/icons/setting.svg?react';
import Staffing from '../../../assets/icons/staffing.svg?react';
import Star from '../../../assets/icons/star.svg?react';
import TickCircle from '../../../assets/icons/tick-circle.svg?react';
import TimerPause from '../../../assets/icons/timer-pause.svg?react';
import TimerStart from '../../../assets/icons/timer-start.svg?react';
import Trash from '../../../assets/icons/trash.svg?react';
import User from '../../../assets/icons/user.svg?react';

/**
 * @typedef {keyof typeof availableIcons} IconType
 */

/**
 * An object mapping icon names to their respective React components.
 * @enum {React.ReactElement}
 */
export const availableIcons = {
  alarm: <Alarm />,
  arrowDown: <ArrowDown />,
  arrowSquareLeft: <ArrowSquareLeft />,
  calendar: <Calendar />,
  cross: <Cross />,
  danger: <Danger />,
  edit: <Edit />,
  eye: <Eye />,
  eyeSlash: <EyeSlash />,
  forbidden: <Forbidden />,
  happyEmoji: <HappyEmoji />,
  home: <Home />,
  infoCircle: <InfoCircle />,
  location: <Location />,
  menu: <Menu />,
  notification: <Notification />,
  presentationChart: <PresentationChart />,
  profile2Users: <Profile2Users />,
  settingAlt: <SettingAlt />,
  setting: <Setting />,
  staffing: <Staffing />,
  star: <Star />,
  tickCircle: <TickCircle />,
  timerPause: <TimerPause />,
  timerStart: <TimerStart />,
  trash: <Trash />,
  user: <User />,
};

/**
 * Icon component that renders an SVG icon from the available icons list.
 *
 * @param {Object} props The props for the Icon component.
 * @param {IconType} props.icon The name of the icon.
 * @param {String} [props.className] The class name for the icon.
 * @param {Object} [props.style] The style for the icon.
 * @returns {React.ReactElement|null}
 */
export function Icon({ ...props }) {
  if (availableIcons[props.icon] === undefined) {
    // eslint-disable-next-line no-console
    console.error(`${props.icon} not in available list of icons`);
    return null;
  }
  return React.cloneElement(availableIcons[props.icon], props);
}
